module.exports = __webpack_public_path__ + "static/media/telegram.41a6b6b4.svg";